<template>
  <div>
    <AccountsCompanySettlementModal
      :selectedCompanyId="companyId"
      :callAllFunctions="callAllFunctions"
    />
    <MasterLayout>
      <div class="pt-4 pb-3 pl-4 pr-3 dashboard_first_row">
        <section
          class="w-100 mb-4 row justify-content-between align-items-center"
        >
          <section class="col-md-8">
            <div class="d-flex align-items-center">
              <div class="text-center dealer__icon__div mr-2">
                <div>
                  <img src="@/assets/img/wallet.svg" width="35px" />
                </div>
              </div>
              <div class="pt-3">
                <h4 class="primary-color font-600">
                  {{ $t("text.omit.remisSales") }}
                </h4>
                <p class="light-grey-text">
                  {{ $t("text.omit.esaleSummary") }}
                </p>
              </div>
            </div>
          </section>

          <section class="col-md-4">
            <div class="text_right">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                :color="$store.getters.getDatePickerColor"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </section>
        </section>

        <div class="row">
          <!-- company wallet balance -->
          <div class="col-md-6">
            <div
              class="py-4 card_container"
              :style="{
                backgroundImage: `url(${cardBackgroundUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right',
                backgroundSize: ' 136px',
              }"
            >
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cMasterLayout.companyWallet") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/wallet.svg" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ company ? company.currencyCode : "" }}
                    {{ decimalThousand(companyWalletBalance) }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <!--  -->

          <!-- remis total -->
          <div class="col-md-6">
            <div
              class="py-4 card_container"
              :style="{
                backgroundImage: `url(${cardBackgroundUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right',
                backgroundSize: ' 136px',
              }"
            >
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    <!-- {{ $t("text.products.total") }} -->
                    {{ $t("text.omit.remisSales") }} ({{ esCount }})
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/wallet.svg" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ company ? company.currencyCode : ""
                    }}{{ decimalThousand(totalAmountSpent) }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <!--  -->

          <!-- difference -->
          <!-- <div class="col-md-4">
            <div
              class="py-4 card_container"
              :style="{
                backgroundImage: `url(${cardBackgroundUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right',
                backgroundSize: ' 136px',
              }"
            >
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cBank.transaction.balance") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/wallet.svg" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ company ? company.currencyCode : "" }} -->
          <!-- {{
                      decimalThousand(
                        Number(companyWalletBalance) + Number(totalAmountSpent)
                      )
                    }} -->
          <!-- {{ decimalThousand(bookbalance) }}
                  </h3>
                </div>
              </div> -->
          <!-- </div>
          </div> -->
          <!--  -->
        </div>
      </div>

      <!-- tabs -->
      <div
        class="d-flex my-3 px-4 flex-column justify-content-between flex-md-row flex-lg-row align-items-center"
      >
        <section class="">
          <div class="d-flex py-2 tabs">
            <div
              @click="() => (this.tabLinked = true)"
              class="mr-4 tab"
              :class="tabLinked && 'activeTab'"
            >
              {{ $t("text.omit.remisSales") }}
            </div>

            <div
              @click="() => (this.tabLinked = false)"
              class="tab"
              :class="!tabLinked && 'activeTab'"
            >
              {{ $t("text.cWallet.title") }}
            </div>
          </div>
        </section>
        <!--  -->

        <section
          class="primary-btn px-3 py-2"
          @click="openSettlementModal"
          v-if="
            (userRoles &&
              userRoles.includes('Post Settlement') &&
              userEmail.includes('@eternaplc.com')) ||
            userRoles.includes('SupportAdmin') ||
            userRoles.includes('Super Admin')
          "
        >
          {{ $t("text.cBank.confirmSettlement") }}
        </section>
      </div>
      <!--  -->

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <!-- remis sales table -->
            <ejs-grid
              v-if="tabLinked"
              v-show="!showLoader"
              :dataSource="remisSales"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="70" field="index" headerText="#"></e-column>

                <e-column
                  field="branchName"
                  width="200"
                  :headerText="$t('text.cDashboard.branchName')"
                ></e-column>
                <!-- <e-column
                  field="volume"
                  width="200"
                  :headerText="$t('text.form.volume')"
                ></e-column> -->
                <e-column
                  width="180"
                  field="salesType"
                  :headerText="$t('text.bWallet.salesType')"
                ></e-column>
                <e-column
                  format="N2"
                  field="amount"
                  width="200"
                  :headerText="`${$t('text.bWallet.amountSpent')} (${
                    company ? company.currency : ''
                  })`"
                ></e-column>
                <e-column
                  width="200"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <!--  -->

            <!-- company wallet table -->

            <ejs-grid
              v-if="!tabLinked"
              :dataSource="companyWalletTransaction"
              v-show="!showLoader2"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :allowTextWrap="true"
              :rowDataBound="rowDataBound"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="70" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.cWallet.date')"
                ></e-column>
                <e-column
                  width="180"
                  field="amount"
                  format="N2"
                  :headerText="$t('text.cWallet.amount')"
                ></e-column>
                <e-column
                  field="walletBalance"
                  width="200"
                  :headerText="$t('text.bWallet.walletBalance')"
                ></e-column>
                <e-column
                  field="source"
                  width="200"
                  :headerText="$t('text.cWallet.source')"
                ></e-column>
                <e-column
                  field="status"
                  width="180"
                  :headerText="$t('text.cWallet.status')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <!--  -->

            <TableLoader v-if="tabLinked" :showLoader="showLoader" />
            <TableLoader v-if="!tabLinked" :showLoader="showLoader2" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
// import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";

import AccountsCompanySettlementModal from "@/components/modals/Accounts/accountsCompanySettlement.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "ESALES :: Epump Portal",
  name: "ESALES",
  components: {
    MasterLayout,
    TableLoader,
    AccountsCompanySettlementModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      companyWalletBalance: 0,
      tabLinked: true,
      remisSales: [],
      companyWalletTransaction: [],
      userRoles: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails")).roles
        : [],
      userEmail: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails")).email
        : "",

      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      company: null,

      // backgroundUrl,
      cardBackgroundUrl,
      companyId: null,
      showLoader: true,
      showLoader2: true,
      esCount: 0,
      totalAmountSpent: 0,
      bookbalance: 0,

      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-outline-dark" title="Details" @click="esDetails(data.branchId)" >' +
              '<i class="fa fa-eye" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              esDetails: function (branchId) {
                this.$eventHub.$emit("_esDetails", branchId);
              },
            },
          }),
        };
      },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getESales();
        this.getWalletTrans();
        this.getCompanyWalletBalance();
      }
    },
    tabLinked(tab) {
      tab ? this.getESales() : this.getWalletTrans();
      this.getCompanyWalletBalance();
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.$router.replace({
          name: this.$route.name,
          query: {
            companyId: this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });

        this.getESales();
        this.getWalletTrans();
        this.getCompanyWalletBalance();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id;
      this.getESales();
      this.getWalletTrans();
      this.getCompanyWalletBalance();
    });
    this.$eventHub.$on("_esDetails", (branchId) => {
      this.$router.push({
        name: "branch_wallet",
        query: {
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id,
          branchId: branchId,
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
        },
      });
    });

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    // this.dateRange.start = this.pluginStartDate;
    // this.dateRange.end = this.pluginEndDate;
  },
  beforeDestroy() {
    this.$eventHub.$off("_esDetails");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }

    // this.updateRouteQuery();
  },
  methods: {
    openSettlementModal() {
      this.$modal.show("accountCompanySettlement");
    },
    callAllFunctions() {
      this.getESales();
      this.getWalletTrans();
      this.getCompanyWalletBalance();
    },
    getWalletTrans() {
      this.showLoader2 = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/WalletTransactions/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.$route.query.startDate}&endDate=${
            this.$route.query.endDate
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          response.data.forEach((element) => {
            element.index = ++index;
            element.amount = element.amount.toLocaleString();
            element.walletBalance = element.walletBalance.toLocaleString();
          });
          this.companyWalletTransaction = response.data;
          // this.$refs.dataGrid.ej2Instances.setProperties({
          //   dataSource: response.data,
          // });
          this.showLoader2 = false;
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader2 = false;
        });
    },

    getCompanyWalletBalance() {
      // this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Wallet/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.companyWalletBalance = response.data.balance;
          this.bookbalance = response.data.bookbalance;
        })
        .catch((error) => {});
    },

    getESales() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/voucher/CompanyEsales/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.$route.query.startDate}&endDate=${
            this.$route.query.endDate
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          //   this.alertAlarm = response.data;
          this.esCount = response.data.length;
          let index = 0;
          const totalAmount = response.data.reduce((a, b) => {
            return a + b.amount;
          }, 0);
          // .toLocaleString();

          this.totalAmountSpent = totalAmount;

          response.data.forEach((element) => {
            element.index = ++index;
          });
          this.remisSales = response.data;
          // this.$refs.dataGrid.ej2Instances.setProperties({
          //   dataSource: response.data,
          // });
          this.showLoader = false;
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    //utilities
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },

    rowDataBound: function (args) {
      if (!this.tabLinked) {
        if (args.data["status"] === "Debit") {
          args.row.cells[5].style.color = "red";
        }
        if (args.data["status"] === "Credit") {
          args.row.cells[5].style.color = "green";
        }
      }
    },

    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Esales_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          // this.$refs.dataGrid.getColumns()[4].visible = false;
          // this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
  },
};
</script>

<style scoped>
.tab {
  color: #4c2e73;
  padding: 0px 6px;
  font-weight: 500;
  cursor: pointer;
}

.activeTab {
  padding-bottom: 6px;
  border-bottom: 3px solid;
}

.primary-btn {
  background-color: #3f1b7e;
  border-radius: 5px;
  color: white;
  cursor: pointer;
}
</style>
